import { useMemo } from "react"
import type { Location } from "@stockline/shared/types/inventory/location"
import { LOCATION_TABLE } from "../../../lib/offline/resources/inventory/location/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UseLocationsFilter {
  includeDeleted?: boolean
}

export function useLocations(filter?: UseLocationsFilter): Location[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<Location>(LOCATION_TABLE, { orderBy: "name" })
  const includeDeleted = filter?.includeDeleted
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
